/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClaimTask,
  ClaimTaskListResponse,
  CreateClaimTaskRequest,
  ErrorEnvelope,
  GetAssignableUsers200Response,
  GlobalTaskListResponse,
  Problem,
  TaskPriority,
  TaskStatus,
  UpdateClaimTaskRequest,
} from '../models/index';
import {
    ClaimTaskFromJSON,
    ClaimTaskToJSON,
    ClaimTaskListResponseFromJSON,
    ClaimTaskListResponseToJSON,
    CreateClaimTaskRequestFromJSON,
    CreateClaimTaskRequestToJSON,
    ErrorEnvelopeFromJSON,
    ErrorEnvelopeToJSON,
    GetAssignableUsers200ResponseFromJSON,
    GetAssignableUsers200ResponseToJSON,
    GlobalTaskListResponseFromJSON,
    GlobalTaskListResponseToJSON,
    ProblemFromJSON,
    ProblemToJSON,
    TaskPriorityFromJSON,
    TaskPriorityToJSON,
    TaskStatusFromJSON,
    TaskStatusToJSON,
    UpdateClaimTaskRequestFromJSON,
    UpdateClaimTaskRequestToJSON,
} from '../models/index';

export interface CompleteClaimTaskRequest {
    claimId: number;
    id: number;
}

export interface CreateClaimTaskOperationRequest {
    claimId: number;
    createClaimTaskRequest: CreateClaimTaskRequest;
}

export interface DeleteClaimTaskRequest {
    claimId: number;
    id: number;
}

export interface GetAllTasksRequest {
    claimId?: number;
    status?: TaskStatus;
    priority?: TaskPriority;
    assignedTo?: number;
    createdBy?: number;
    dueDateFrom?: Date;
    dueDateTo?: Date;
    includeCompleted?: boolean;
    sortBy?: GetAllTasksSortByEnum;
    sortOrder?: GetAllTasksSortOrderEnum;
    page?: number;
    limit?: number;
}

export interface GetClaimTaskRequest {
    claimId: number;
    id: number;
}

export interface GetClaimTasksRequest {
    claimId: number;
    status?: TaskStatus;
    priority?: TaskPriority;
    assignedTo?: number;
    includeCompleted?: boolean;
    sortBy?: GetClaimTasksSortByEnum;
    sortOrder?: GetClaimTasksSortOrderEnum;
}

export interface GetTaskAssigneesRequest {
    claimId: number;
}

export interface UpdateClaimTaskOperationRequest {
    claimId: number;
    id: number;
    updateClaimTaskRequest: UpdateClaimTaskRequest;
}

/**
 * TasksApi - interface
 * 
 * @export
 * @interface TasksApiInterface
 */
export interface TasksApiInterface {
    /**
     * 
     * @summary Mark a task as completed
     * @param {number} claimId Claim ID
     * @param {number} id Task ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    completeClaimTaskRaw(requestParameters: CompleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>>;

    /**
     * Mark a task as completed
     */
    completeClaimTask(requestParameters: CompleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask>;

    /**
     * 
     * @summary Create a new task for a claim
     * @param {number} claimId Claim ID
     * @param {CreateClaimTaskRequest} createClaimTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    createClaimTaskRaw(requestParameters: CreateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>>;

    /**
     * Create a new task for a claim
     */
    createClaimTask(requestParameters: CreateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask>;

    /**
     * 
     * @summary Delete a task
     * @param {number} claimId Claim ID
     * @param {number} id Task ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    deleteClaimTaskRaw(requestParameters: DeleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete a task
     */
    deleteClaimTask(requestParameters: DeleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieve tasks across all claims for the user\'s company with filtering and pagination
     * @summary Get all tasks across claims
     * @param {number} [claimId] Filter by specific claim ID
     * @param {TaskStatus} [status] Filter by task status
     * @param {TaskPriority} [priority] Filter by task priority
     * @param {number} [assignedTo] Filter by assigned user ID
     * @param {number} [createdBy] Filter by creator user ID
     * @param {Date} [dueDateFrom] Filter tasks with due date on or after this date
     * @param {Date} [dueDateTo] Filter tasks with due date on or before this date
     * @param {boolean} [includeCompleted] Include completed tasks
     * @param {'dueDate' | 'createdAt' | 'status' | 'priority'} [sortBy] Field to sort by
     * @param {'asc' | 'desc'} [sortOrder] Sort order
     * @param {number} [page] Page number for pagination
     * @param {number} [limit] Number of items per page
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    getAllTasksRaw(requestParameters: GetAllTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlobalTaskListResponse>>;

    /**
     * Retrieve tasks across all claims for the user\'s company with filtering and pagination
     * Get all tasks across claims
     */
    getAllTasks(requestParameters: GetAllTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlobalTaskListResponse>;

    /**
     * 
     * @summary Get a specific task
     * @param {number} claimId Claim ID
     * @param {number} id Task ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    getClaimTaskRaw(requestParameters: GetClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>>;

    /**
     * Get a specific task
     */
    getClaimTask(requestParameters: GetClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask>;

    /**
     * Retrieve all tasks associated with a specific claim with optional filtering
     * @summary Get all tasks for a claim
     * @param {number} claimId Claim ID
     * @param {TaskStatus} [status] Filter by task status
     * @param {TaskPriority} [priority] Filter by task priority
     * @param {number} [assignedTo] Filter by assigned user ID
     * @param {boolean} [includeCompleted] Include completed tasks
     * @param {'dueDate' | 'createdAt' | 'status' | 'priority'} [sortBy] Field to sort by
     * @param {'asc' | 'desc'} [sortOrder] Sort order
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    getClaimTasksRaw(requestParameters: GetClaimTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTaskListResponse>>;

    /**
     * Retrieve all tasks associated with a specific claim with optional filtering
     * Get all tasks for a claim
     */
    getClaimTasks(requestParameters: GetClaimTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTaskListResponse>;

    /**
     * Returns all active users who have access to this claim and can be assigned to tasks. This includes: 1. Users with explicit user-type claim_access grants 2. Users whose company has a company-type claim_access grant (cross-company access) 3. Admins and owners of the claim\'s company (implicit access via role) 4. The claim creator (implicit member access)  Note: Only returns users with \'active\' account status. 
     * @summary Get users assignable to tasks for this claim
     * @param {number} claimId Claim ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    getTaskAssigneesRaw(requestParameters: GetTaskAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssignableUsers200Response>>;

    /**
     * Returns all active users who have access to this claim and can be assigned to tasks. This includes: 1. Users with explicit user-type claim_access grants 2. Users whose company has a company-type claim_access grant (cross-company access) 3. Admins and owners of the claim\'s company (implicit access via role) 4. The claim creator (implicit member access)  Note: Only returns users with \'active\' account status. 
     * Get users assignable to tasks for this claim
     */
    getTaskAssignees(requestParameters: GetTaskAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssignableUsers200Response>;

    /**
     * 
     * @summary Update a task
     * @param {number} claimId Claim ID
     * @param {number} id Task ID
     * @param {UpdateClaimTaskRequest} updateClaimTaskRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TasksApiInterface
     */
    updateClaimTaskRaw(requestParameters: UpdateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>>;

    /**
     * Update a task
     */
    updateClaimTask(requestParameters: UpdateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask>;

}

/**
 * 
 */
export class TasksApi extends runtime.BaseAPI implements TasksApiInterface {

    /**
     * Mark a task as completed
     */
    async completeClaimTaskRaw(requestParameters: CompleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling completeClaimTask().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling completeClaimTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/tasks/{id}/complete`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTaskFromJSON(jsonValue));
    }

    /**
     * Mark a task as completed
     */
    async completeClaimTask(requestParameters: CompleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask> {
        const response = await this.completeClaimTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a new task for a claim
     */
    async createClaimTaskRaw(requestParameters: CreateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling createClaimTask().'
            );
        }

        if (requestParameters['createClaimTaskRequest'] == null) {
            throw new runtime.RequiredError(
                'createClaimTaskRequest',
                'Required parameter "createClaimTaskRequest" was null or undefined when calling createClaimTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/tasks`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreateClaimTaskRequestToJSON(requestParameters['createClaimTaskRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTaskFromJSON(jsonValue));
    }

    /**
     * Create a new task for a claim
     */
    async createClaimTask(requestParameters: CreateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask> {
        const response = await this.createClaimTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Delete a task
     */
    async deleteClaimTaskRaw(requestParameters: DeleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling deleteClaimTask().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteClaimTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/tasks/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete a task
     */
    async deleteClaimTask(requestParameters: DeleteClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteClaimTaskRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieve tasks across all claims for the user\'s company with filtering and pagination
     * Get all tasks across claims
     */
    async getAllTasksRaw(requestParameters: GetAllTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GlobalTaskListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['claimId'] != null) {
            queryParameters['claimId'] = requestParameters['claimId'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['priority'] != null) {
            queryParameters['priority'] = requestParameters['priority'];
        }

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assignedTo'] = requestParameters['assignedTo'];
        }

        if (requestParameters['createdBy'] != null) {
            queryParameters['createdBy'] = requestParameters['createdBy'];
        }

        if (requestParameters['dueDateFrom'] != null) {
            queryParameters['dueDateFrom'] = (requestParameters['dueDateFrom'] as any).toISOString();
        }

        if (requestParameters['dueDateTo'] != null) {
            queryParameters['dueDateTo'] = (requestParameters['dueDateTo'] as any).toISOString();
        }

        if (requestParameters['includeCompleted'] != null) {
            queryParameters['includeCompleted'] = requestParameters['includeCompleted'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/tasks`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GlobalTaskListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve tasks across all claims for the user\'s company with filtering and pagination
     * Get all tasks across claims
     */
    async getAllTasks(requestParameters: GetAllTasksRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GlobalTaskListResponse> {
        const response = await this.getAllTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a specific task
     */
    async getClaimTaskRaw(requestParameters: GetClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimTask().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getClaimTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/tasks/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTaskFromJSON(jsonValue));
    }

    /**
     * Get a specific task
     */
    async getClaimTask(requestParameters: GetClaimTaskRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask> {
        const response = await this.getClaimTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieve all tasks associated with a specific claim with optional filtering
     * Get all tasks for a claim
     */
    async getClaimTasksRaw(requestParameters: GetClaimTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTaskListResponse>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getClaimTasks().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        if (requestParameters['priority'] != null) {
            queryParameters['priority'] = requestParameters['priority'];
        }

        if (requestParameters['assignedTo'] != null) {
            queryParameters['assignedTo'] = requestParameters['assignedTo'];
        }

        if (requestParameters['includeCompleted'] != null) {
            queryParameters['includeCompleted'] = requestParameters['includeCompleted'];
        }

        if (requestParameters['sortBy'] != null) {
            queryParameters['sortBy'] = requestParameters['sortBy'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['sortOrder'] = requestParameters['sortOrder'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/tasks`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTaskListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieve all tasks associated with a specific claim with optional filtering
     * Get all tasks for a claim
     */
    async getClaimTasks(requestParameters: GetClaimTasksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTaskListResponse> {
        const response = await this.getClaimTasksRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns all active users who have access to this claim and can be assigned to tasks. This includes: 1. Users with explicit user-type claim_access grants 2. Users whose company has a company-type claim_access grant (cross-company access) 3. Admins and owners of the claim\'s company (implicit access via role) 4. The claim creator (implicit member access)  Note: Only returns users with \'active\' account status. 
     * Get users assignable to tasks for this claim
     */
    async getTaskAssigneesRaw(requestParameters: GetTaskAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetAssignableUsers200Response>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling getTaskAssignees().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/tasks/task-assignees`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetAssignableUsers200ResponseFromJSON(jsonValue));
    }

    /**
     * Returns all active users who have access to this claim and can be assigned to tasks. This includes: 1. Users with explicit user-type claim_access grants 2. Users whose company has a company-type claim_access grant (cross-company access) 3. Admins and owners of the claim\'s company (implicit access via role) 4. The claim creator (implicit member access)  Note: Only returns users with \'active\' account status. 
     * Get users assignable to tasks for this claim
     */
    async getTaskAssignees(requestParameters: GetTaskAssigneesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetAssignableUsers200Response> {
        const response = await this.getTaskAssigneesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a task
     */
    async updateClaimTaskRaw(requestParameters: UpdateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ClaimTask>> {
        if (requestParameters['claimId'] == null) {
            throw new runtime.RequiredError(
                'claimId',
                'Required parameter "claimId" was null or undefined when calling updateClaimTask().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateClaimTask().'
            );
        }

        if (requestParameters['updateClaimTaskRequest'] == null) {
            throw new runtime.RequiredError(
                'updateClaimTaskRequest',
                'Required parameter "updateClaimTaskRequest" was null or undefined when calling updateClaimTask().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/claims/{claimId}/tasks/{id}`.replace(`{${"claimId"}}`, encodeURIComponent(String(requestParameters['claimId']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateClaimTaskRequestToJSON(requestParameters['updateClaimTaskRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ClaimTaskFromJSON(jsonValue));
    }

    /**
     * Update a task
     */
    async updateClaimTask(requestParameters: UpdateClaimTaskOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ClaimTask> {
        const response = await this.updateClaimTaskRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

/**
 * @export
 */
export const GetAllTasksSortByEnum = {
    DueDate: 'dueDate',
    CreatedAt: 'createdAt',
    Status: 'status',
    Priority: 'priority'
} as const;
export type GetAllTasksSortByEnum = typeof GetAllTasksSortByEnum[keyof typeof GetAllTasksSortByEnum];
/**
 * @export
 */
export const GetAllTasksSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetAllTasksSortOrderEnum = typeof GetAllTasksSortOrderEnum[keyof typeof GetAllTasksSortOrderEnum];
/**
 * @export
 */
export const GetClaimTasksSortByEnum = {
    DueDate: 'dueDate',
    CreatedAt: 'createdAt',
    Status: 'status',
    Priority: 'priority'
} as const;
export type GetClaimTasksSortByEnum = typeof GetClaimTasksSortByEnum[keyof typeof GetClaimTasksSortByEnum];
/**
 * @export
 */
export const GetClaimTasksSortOrderEnum = {
    Asc: 'asc',
    Desc: 'desc'
} as const;
export type GetClaimTasksSortOrderEnum = typeof GetClaimTasksSortOrderEnum[keyof typeof GetClaimTasksSortOrderEnum];
